import { getData, postData } from '@/assets/js/api.js'

// 获取用户区域树
export const FindUserAreaTree = (params, fn, header) => {
  const methods = '/api/Area/FindUserAreaTree'
  return getData(methods, params, 1, fn, undefined, header)
}
// 获取区域
export const FindArea = (params, fn) => {
  const methods = '/api/Area/FindArea'
  return getData(methods, params, 1, fn)
}

// 创建区域
export const Create = (params, fn) => {
  const methods = '/api/Area/Create'
  postData(methods, params, 1, fn)
}

// 编辑区域
export const Edit = (params, fn) => {
  const methods = '/api/Area/Edit'
  postData(methods, params, 1, fn)
}

// 删除区域
export const DeleteArea = (params, fn) => {
  const methods = '/api/Area/DeleteArea'
  getData(methods, params, 1, fn)
}

// 开灯
export const OpenLight = (params, fn) => {
  const methods = '/api/Area/OpenLight'
  getData(methods, params, 1, fn)
}

// 关灯
export const CloseLight = (params, fn) => {
  const methods = '/api/Area/CloseLight'
  getData(methods, params, 1, fn)
}
//感应模式
export const LightMode = (params, fn) =>{
  const methods = '/api/Area/LightMode'
  return getData(methods, params, 1, fn)
}
//情景号
export const GetCallScene = (params, fn) => {
  const methods = '/api/Area/CallScene'
  return getData(methods, params, 1, fn)
}
// 调节亮度
export const AdjustBright = (params, fn) => {
  const methods = '/api/Area/AdjustBright'
  getData(methods, params, 1, fn)
}

// 调节色温
export const AdjustTemperature = (params, fn) => {
  const methods = '/api/Area/AdjustTemperature'
  getData(methods, params, 1, fn)
}

// 调节颜色
export const AdjustColor = (params, fn) => {
  const methods = '/api/Area/AdjustColor'
  getData(methods, params, 1, fn)
}

// 分级调亮
export const StepDimming = (params, fn) => {
  const methods = '/api/Area/StepDimming'
  getData(methods, params, 1, fn)
}

// 分级调色温
export const StepCCT = (params, fn) => {
  const methods = '/api/Area/StepAdjustCCT'
  getData(methods, params, 1, fn)
}

// 添加设备到区域
export const AddDevice = (params, fn) => {
  const methods = '/api/Area/AddDevice'
  postData(methods, params, 1, fn)
}
// 添加设备到区域 - 批量
export const BatchAddDevice = (params, fn) => {
  const methods = '/api/Area/BatchAddDevice1'
  return postData(methods, params, 1, fn)
}

// 移动设备到另一个区域
export const MoveDevice = (params, fn) => {
  const methods = '/api/Area/MoveDevice'
  getData(methods, params, 1, fn)
}
// 移动设备到另一个区域 - 批量
export const BatchMoveDevice = (params, fn) => {
  const methods = '/api/Area/BatchMoveDevice1'
  return postData(methods, params, 1, fn)
}

// 查询当前同步(设备入区域)结果
export const ShowCurrentSyncResult = (params, fn) => {
  const methods = '/api/Area/ShowCurrentSyncResult'
  postData(methods, params, 1, fn)
}

// 查询历史同步(设备入区域)结果
export const ShowHistorySyncResult = (params, fn) => {
  const methods = '/api/Area/ShowHistorySyncResult'
  getData(methods, params, 1, fn)
}

// 重新下发区域号
export const ReSyncAreaCode = (params, fn) => {
  const methods = '/api/Area/ReSyncAreaCode'
  getData(methods, params, 1, fn)
}

// 查询该区域下的设备有多少个网关
export const FindGatewayList = (params, fn) => {
  const methods = '/api/Area/FindGatewayList'
  getData(methods, params, 1, fn)
}

// 从区域中移除设备
export const RemoveDevice = (params, fn) => {
  const methods = '/api/Area/RemoveDevice'
  getData(methods, params, 1, fn)
}

// 验证两个区域下的设备映射关系
export const VerifyDeviceMapInArea = (params, fn) => {
  const methods = '/api/Area/VerifyDeviceMapInArea'
  postData(methods, params, 1, fn)
}

// 验证复制时两个区域的IFTTT是否符合规则
export const VerifyIFTTTInArea = (params, fn) => {
  const methods = '/api/Area/VerifyIFTTTInArea'
  postData(methods, params, 1, fn)
}

// 复制区域下的Ifttt
export const CopyIFTTTInArea = (params, fn) => {
  const methods = '/api/Area/CopyIFTTTInArea'
  postData(methods, params, 1, fn)
}

// 更新区域的图片Path
export const UpdateAreaPath = (params, fn, data) => {
  const methods = '/api/Area/UpdateAreaPath'
  postData(methods, params, 1, fn, data)
}

// 更新区域的图片Path
export const GetAreaTree = (params, fn, data) => {
  const methods = '/api/Area/GetAreaTree'
  return postData(methods, params, 1, fn, data)
}

// 更新区组号映射
export const SaveOrUpdateAreaAndAddressMap = (params, fn, data) => {
  const methods = '/businessapi/Area/SaveOrUpdateAreaAndAddressMap'
  return postData(methods, params, 1, fn, data)
}

// 获取区组号映射
export const GetAreaAndAddressMapList = (params, fn) => {
  const methods = '/businessapi/Area/GetAreaAndAddressMapList'
  return getData(methods, params, 1, fn)
}

// 获取区组号映射
export const UpdateAreaSort = (params, fn) => {
  const methods = '/api/Area/UpdateAreaSort';
  return postData(methods, params, 1, fn);
}

// 获取区域树模版
export const GetAreaExcel = (params, fn) => {
  const methods = '/api/Package/GetAreaExcel'
  return getData(methods, params, 1, fn)
}

// 上传区域树模版
export const ExcelCreateArea = (params, fn,extendHeader) => {
  const methods = '/api/Package/ExcelCreateArea';
  return postData(methods, params, 3, fn, {} , extendHeader);
}

// 区域树排序
export const SetAreaSort = (params, fn,extendHeader) => {
  const methods = '/api/Area/SetAreaSort';
  return postData(methods, params, 1, fn, {} , extendHeader);
}

//设置目标区域
export const SetTargetArea = (params, fn) => {
  const methods = '/api/Area/SetTargetArea'
  return postData(methods, params, 1, fn)
}

//一键移动
export const MoveToTargetArea = (params, fn) => {
  const methods = '/api/Area/MoveToTargetArea'
  return postData(methods, params, 1, fn)
}

//设置区域 DLI 参数（全开光强锚定值、人工/自然光 DLI 目标值、自动关灯）
export const UpdateAreaDLISettings = (params, fn) => {
  const methods = '/api/area/UpdateAreaDLISettings'
  return postData(methods, params, 1, fn)
}

//获取区域当天开灯累计时长GET /businessapi/stat/GetLightStatisticsByArea
export const GetLightStatisticsByArea = (params, fn) => {
  const methods = '/businessapi/stat/GetLightStatisticsByArea'
  return getData(methods, params, 1, fn)
}

//获取区域农业传感器补光参数
export const GetAreaLightSupplementSettings = (params, fn) => {
  const methods = '/api/area/GetAreaLightSupplementSettings'
  return getData(methods, params, 1, fn)
}

// 导出灯具运行记录
export const ExportLightoperationRecordsV2 = (params, fn) => {
  const methods = '/businessapi/stat/ExportLightoperationRecordsV2'
  return getData(methods, params, 1, fn)
}

// 导出区域绑定农业传感器数据
export const ExportAgriculturesensorReport = (params, fn) => {
  const methods = '/businessapi/stat/ExportAgriculturesensorReport'
  return getData(methods, params, 1, fn)
}





